'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Truck = require('./Truck');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Truck).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Truck/index.js
// module id = 1308
// module chunks = 1